module.exports = __webpack_public_path__ + "img/hr-boiler-E-fire.b79aadc7.png";